import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { VERSION } from '../version';

type HealthResp = {
  status: string;
  app_name?: string;
  app_env?: string;
  database?: string;
};

export default function DiagnosticsPage() {
  const [health, setHealth] = useState<HealthResp | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetch('/api/v1/health')
      .then((r) => r.json())
      .then(setHealth)
      .catch((e) => setError(String(e)));
  }, []);

  return (
    <main className="min-h-screen bg-background text-white flex items-center justify-center px-6 py-10">
      <div className="w-full max-w-2xl rounded-3xl border border-theme-border bg-theme-surface p-8 shadow-2xl shadow-black/10">
        <p className="text-xs uppercase tracking-[0.28em] text-theme-text-muted">Diagnostics</p>
        <h1 className="mt-2 text-3xl font-semibold">Reporter backend health</h1>
        <p className="mt-3 text-sm text-theme-text-secondary">
          Frontend v{VERSION}. This page is intentionally separate from the primary landing shell.
        </p>

        <div className="mt-6 flex flex-wrap gap-3">
          <Link
            to="/"
            className="rounded-full bg-theme-accent px-4 py-2 text-sm font-semibold text-theme-accent-fg"
          >
            Back to landing
          </Link>
          <Link
            to="/editor"
            className="rounded-full border border-theme-border px-4 py-2 text-sm font-semibold text-theme-text-primary"
          >
            Open editor
          </Link>
        </div>

        <section className="mt-6 rounded-2xl border border-theme-border bg-theme-bg p-4">
          <h2 className="text-lg font-semibold mb-2">Backend health</h2>
          {error && <pre className="text-red-400 text-sm whitespace-pre-wrap">{error}</pre>}
          {!error && !health && <p className="text-sm text-theme-text-secondary">Loading…</p>}
          {health && (
            <pre className="text-sm whitespace-pre-wrap text-theme-text-primary">
              {JSON.stringify(health, null, 2)}
            </pre>
          )}
        </section>
      </div>
    </main>
  );
}
